export default "__VITE_ASSET__8T8w5_D1__"